<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.93,5.63C15.93,5.63,15.93,5.63,15.93,5.63C15.93,5.63,15.93,5.61,15.93,5.61C15.93,5.61,15.93,5.61,15.93,5.61C15.93,5.61,13.94,0.63,13.94,0.63C13.94,0.63,13.94,0.63,13.94,0.63C13.78,0.26,13.42,0,13,0C13,0,3,0,3,0C2.58,0,2.22,0.26,2.07,0.63C2.07,0.63,2.07,0.63,2.07,0.63C2.07,0.63,0.08,5.61,0.08,5.61C0.08,5.61,0.08,5.61,0.08,5.61C0.08,5.61,0.07,5.63,0.07,5.63C0.07,5.63,0.07,5.63,0.07,5.63C0.03,5.74,0,5.87,0,6C0,6,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,6,16,6C16,5.87,15.97,5.74,15.93,5.63C15.93,5.63,15.93,5.63,15.93,5.63ZM9,2C9,2,12.32,2,12.32,2C12.32,2,13.52,5,13.52,5C13.52,5,9,5,9,5C9,5,9,2,9,2C9,2,9,2,9,2ZM3.68,2C3.68,2,7,2,7,2C7,2,7,5,7,5C7,5,2.48,5,2.48,5C2.48,5,3.68,2,3.68,2C3.68,2,3.68,2,3.68,2ZM14,14C14,14,2,14,2,14C2,14,2,7,2,7C2,7,7,7,7,7C7,7,7,9.59,7,9.59C7,9.59,5.71,8.29,5.71,8.29C5.53,8.11,5.28,8,5,8C4.45,8,4,8.45,4,9C4,9.28,4.11,9.53,4.29,9.71C4.29,9.71,7.29,12.71,7.29,12.71C7.47,12.89,7.72,13,8,13C8.28,13,8.53,12.89,8.71,12.71C8.71,12.71,11.71,9.71,11.71,9.71C11.89,9.53,12,9.28,12,9C12,8.45,11.55,8,11,8C10.72,8,10.47,8.11,10.29,8.29C10.29,8.29,9,9.59,9,9.59C9,9.59,9,7,9,7C9,7,14,7,14,7C14,7,14,14,14,14C14,14,14,14,14,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Compressed',
} as DefineComponent
</script>
